import {ORDER_STATUS, REPLY_STATUS} from "../../../../utils/codes";
import * as formatter from "../../../../utils/formatter";
// import {format, subDays} from "date-fns";

export const defaultSorted = [{ dataField: "no", order: "asc" }];

export const orderStatusOptions = ORDER_STATUS.map(({key, label}) => ({ key, label }))
export const replyStatusOptions = REPLY_STATUS.map(({key, label}) => ({ key, label }))

export const sizePerPageList = [
  { text: "10개 보기", value: 10 },
  { text: "30개 보기", value: 30 },
  { text: "50개 보기", value: 50 },
  { text: "100개 보기", value: 100 },
];

export const initialFilter = {
  filter: {
    ordNo: "",
    ansSttsCd: "",
    ordSttsCd: "",
    goodsNm: "",
    ordUserNm: "",
    ordStartDt: "",
    ordEndDt: "",
    csStartDt: "",
    csEndDt: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "no",
  pageNumber: 1,
  pageSize: 30
};

export const columns = [
  {
    keyField: "no",
    dataField: "no",
    text: "No.",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "ordNo",
    text: "주문번호",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "ordUserNm",
    text: "주문자명",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "title",
    text: "문의제목",
    headerClasses: 'text-center',
    classes: 'text-left',
  },
  {
    keyField: "no",
    dataField: "ordDtime",
    text: "주문일시",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.dateTime,
  },
  {
    keyField: "no",
    dataField: "queDtime",
    text: "문의일시",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.dateTime,
  },
  {
    keyField: "no",
    dataField: "ansSttsCd",
    text: "답변상태",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.chip(REPLY_STATUS),
  },
  {
    keyField: "no",
    dataField: "ordSttsCd",
    text: "주문상태",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.dot(ORDER_STATUS),
  },
];
